module.exports = __webpack_public_path__ + "static/media/Paddle Surfer.3ff3a693.jpg";